import { useRouter } from 'next/router';

export const usePathMatch = () => {
  const router = useRouter();
  const currentPath = router.asPath.toLowerCase();

  const cleanUrlPath = (path: string) => path.trim().toLowerCase();

  const isCurrentPathMatched = (matchList?: string): boolean => {
    if (!currentPath || !matchList) return false;

    const pathsMatchList = matchList.split(/\r?\n/).map((path) => cleanUrlPath(path));
    return pathsMatchList.some((path) => {
      if (!path) return false;

      if (path.endsWith('*')) {
        const basePath = path.slice(0, -1); // Remove the wildcard character
        return currentPath.startsWith(basePath);
      }

      return currentPath === path;
    });
  };

  const matchRegex = (regex: RegExp) => {
    return currentPath.match(regex);
  };

  return { isCurrentPathMatched, matchRegex };
};
